/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IGetCartLineNutritionDetailsResponse } from '../custom-actions/DataServiceEntities.g';
import { lAC_ITSGetItemNutritionDetailsAsync } from '../custom-actions/DataActionExtension.g';

/**
 * GetItemNutritionDetails Input Action
 */
export class GetItemNutritionDetailsInput implements Msdyn365.IActionInput {
    public itemId: string;
    constructor(itemId: string) {
        this.itemId = itemId;
    }

    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GETITEMNUTRITIONDETAILS-${this.itemId}`;
    public getCacheObjectType = () => 'GETITEMNUTRITIONDETAILS';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

async function getItemNutritionDetailsAsync(
    input: GetItemNutritionDetailsInput,
    ctx: Msdyn365.IActionContext
): Promise<IGetCartLineNutritionDetailsResponse> {
    try {
        const result = await lAC_ITSGetItemNutritionDetailsAsync({ callerContext: ctx }, input.itemId);
        if (result) {
            return result;
        }
    } catch (error) {
        console.log('Error', error);
    }
    return {};
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetCartLineNutritionDetailsResponse>>getItemNutritionDetailsAsync,
    id: 'GetItemNutritionDetails'
});
